import { JSX, memo, useMemo, useEffect, lazy, Suspense } from "react";
import logo from "@/assets/img/logo.webp";
import bgAnimal from "@/assets/img/bg-animal.webp";
import logo150 from "@/assets/img/logo-150.webp";
import logo250 from "@/assets/img/logo-250.webp";
import logo400 from "@/assets/img/logo-400.webp";

const styles = {
  container: "flex h-screen flex-col items-center justify-center bg-cover bg-center bg-no-repeat",
  card: "w-full max-w-md bg-white shadow-lg sm:rounded-lg rounded-none sm:h-auto h-full flex flex-col items-center justify-center",
  content: "p-6 sm:p-8",
  logoWrapper: "mb-6 flex justify-center",
  title: "mb-6 text-center text-2xl font-bold text-dark sm:text-3xl",
  footer: "mt-6 text-center text-sm text-gray-600",
  footerText: "text-gray-600",
  copyrightText: "mb-3 text-center text-sm leading-6 text-slate-500",
};

const Signin = lazy(() => import("./components/signin"));

const currentYear: number = new Date().getFullYear();

const LoginContainer = (): JSX.Element => {
  const bgStyle = useMemo(() => ({ backgroundImage: `url(${bgAnimal})` }), []);

  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = logo;
    link.type = 'image/webp';
    document.head.appendChild(link);
    return () => {
      document.head.removeChild(link);
    };
  }, []);

  return (
    <Suspense fallback={<></>}>
      <div
        className={styles.container}
        style={bgStyle}
      >
        <div className={styles.card}>
          <div className={styles.content}>
            <div className={styles.logoWrapper}>
              <img
                src={logo250}
                srcSet={`${logo150} 150w, ${logo250} 250w, ${logo400} 400w`}
                sizes="(max-width: 600px) 150px, 250px"
                alt="Logo de AppCotas"
                width={250}
                height={176}
                loading="eager"
                decoding="async"
                fetchPriority="high"
                style={{ contentVisibility: "auto" }}
              />
            </div>
            <h1 className={styles.title}>Bienvenido</h1>
            <Signin />
            <p className={styles.copyrightText}>
              © {currentYear} AppCotas - Todos los derechos reservados.
            </p>
          </div>
        </div>
      </div>
    </Suspense>
  );
};

export default memo(LoginContainer);